module.exports = __webpack_public_path__ + "img/checklist-button-hand.b1dbef7f.png";